import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import StudentMessageThread from '../components/StudentMessageThread';
import { useAuth } from '../context/AuthContext';

export default function MyMessagesPage() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const [threads, setThreads] = useState([]);
  const [children, setChildren] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const studentId = searchParams.get('student_id') || '';
  const teacherId = searchParams.get('teacher_id') || '';

  useEffect(() => {
    if (!user?.is_parent) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/parent/children/');
        if (!cancelled) {
          const list = Array.isArray(res.data) ? res.data : res.data?.results || [];
          setChildren(list);
        }
      } catch {
        if (!cancelled) setChildren([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const params = {};
        if (studentId) params.student_id = studentId;
        const res = await api.get('/messaging/me/threads/', { params });
        if (!cancelled) {
          setThreads(res.data?.threads || []);
          if (!teacherId && (res.data?.threads || []).length === 1) {
            setSearchParams((prev) => {
              const next = new URLSearchParams(prev);
              next.set('teacher_id', String(res.data.threads[0].teacher_id));
              return next;
            });
          }
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.detail || 'Не удалось загрузить переписку');
          setThreads([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [studentId, teacherId, setSearchParams]);

  const active = threads.find((t) => String(t.teacher_id) === String(teacherId));

  return (
    <div className="sched-page">
      <div className="page-header">
        <h1>Сообщения</h1>
        <p className="page-subtitle">
          Организационная лента с преподавателем на сайте. Внешние мессенджеры — по желанию.
        </p>
      </div>

      {user?.is_parent && children.length > 0 && (
        <label className="sched-filter">
          Ребёнок
          <select
            value={studentId}
            onChange={(e) => {
              const v = e.target.value;
              const next = {};
              if (v) next.student_id = v;
              setSearchParams(next);
            }}
          >
            <option value="">По умолчанию</option>
            {children.map((c) => (
              <option key={c.id} value={c.id}>
                {c.display_name || c.first_name || c.username}
              </option>
            ))}
          </select>
        </label>
      )}

      {error && <div className="alert alert-error">{error}</div>}
      {loading && <p>Загрузка…</p>}

      {!loading && threads.length === 0 && (
        <p className="muted">Нет активных преподавателей для переписки.</p>
      )}

      {!loading && threads.length > 0 && (
        <div className="ops-messages-layout">
          <aside className="ops-messages-aside">
            <ul className="ops-thread-picker">
              {threads.map((t) => (
                <li key={t.thread_id}>
                  <button
                    type="button"
                    className={
                      String(t.teacher_id) === String(teacherId)
                        ? 'ops-thread-picker-item is-active'
                        : 'ops-thread-picker-item'
                    }
                    onClick={() => {
                      const next = { teacher_id: String(t.teacher_id) };
                      if (studentId) next.student_id = studentId;
                      setSearchParams(next);
                    }}
                  >
                    <span>{t.teacher_name}</span>
                    {t.unread_count > 0 && (
                      <span className="badge">{t.unread_count}</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
            <p className="muted">
              <Link to="/my-schedule">К расписанию</Link>
              {' — перенос и отмена отдельной формой.'}
            </p>
          </aside>
          <div className="ops-messages-main">
            {active ? (
              <StudentMessageThread
                mode="student"
                teacherId={active.teacher_id}
                studentId={studentId || undefined}
              />
            ) : (
              <p className="muted">Выберите преподавателя слева.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
